import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
const axios = require("axios").default;

const BillPrintBody = (props) => {
  const { slug } = props.slug;
  const { setIsLoading } = {...props};
//   const { setIsLoading } = props.setIsLoading;
  const [billingOrderMasters, setBillingOrderMasters] = useState({});
  const [billingOrderDetails, setBillingOrderDetails] = useState([]);
  const [billingOrderTransactoins, setBillingOrderTransactoins] = useState([]);
  const [dentrinoPatientInfos, setDentrinoPatientInfos] = useState({});
  // calculation
  const [subTotal, setSubTotal] = useState(0);

  const serverDateToReadableDate = (newDate) => {
    if (!newDate) {
      return newDate;
    }
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const entryDate = new Date(
      (typeof newDate === "string"
        ? new Date(newDate)
        : newDate
      ).toLocaleString("en-US")
    );
    const currentMonth = entryDate.getMonth() + 1;
    const currentDate = entryDate.getDate();

    const readableDate = `${
      currentDate < 10 ? "0" + currentDate : currentDate
    }-${monthNames[entryDate.getMonth()]}-${entryDate.getFullYear()}`;
    // const  readableDate = `${currentDate<10 ? '0'+currentDate : currentDate}-${ currentMonth<10 ? '0'+currentMonth : currentMonth }-${entryDate.getFullYear()}`
    // console.log(  entryDate.getFullYear(), entryDate.getMonth()+1)
    return readableDate;
  };

  // axios call
  const getBillsData = () => {
    setIsLoading(true);
    axios
      .get("/bill-print/" + slug)
      //   .get("/billing-order/" + slug)
      .then((response) => {
        setIsLoading(false);
        console.log(response.data);
        setBillingOrderMasters(response.data.billingOrderMaster);
        setBillingOrderDetails(response.data.billingOrderDetail);
        setBillingOrderTransactoins(response.data.billingOrderTransaction);
        setDentrinoPatientInfos(response.data.patientManager);

        // window.print(); 
        // window.close();
      })
      .catch((errors) => {
        setIsLoading(false);
        console.error(errors);
      });
  };
  // axios call end

  useEffect(() => {
    // get billDetails [ orderDeatils, orderMaster, orderTransaction ]
    getBillsData();
    // bill HeaderFooter details.
  }, []);

  useEffect(() => {
    let subTotalAmount = 0;
    billingOrderDetails.map((itemDetail) => {
      const lineTotal = itemDetail.qty * parseInt(itemDetail.mrp);
      subTotalAmount += lineTotal;
    });
    setSubTotal(subTotalAmount);
  }, [billingOrderDetails]);
  return (
    <>
      {/* patient info  */}
      <div className="grid-container">
        <div className="flexItemsCenter">
          <div> PID : {dentrinoPatientInfos.custom_id} </div>
          <div> P.Name : {dentrinoPatientInfos.patient_name} </div>
          <div> Contact : {dentrinoPatientInfos.phone_number} </div>
        </div>
        <div className="flexItemsCenter">
          <div>{billingOrderMasters.custom_id} </div>
          <div> Invoice ID : {billingOrderMasters.id} </div>
          <div>
            {" "}
            Invoice Date :{" "}
            {serverDateToReadableDate(billingOrderMasters.created_at)}{" "}
          </div>
        </div>
        <div className="flexItemsCenter" style={{ alignItems: "center" }}>
          <QRCode value="http://localhost:3000/bill-print/39" size={100} />
        </div>
      </div>
      {/* patient info  end*/}
      <table
        className="table"
        width="100%"
        style={{ marginBottom: 0, borderCollapse: "collapse" }}
      >
        <tbody>
          <tr>
            <td width="45%" className="primaryTableHead">
              <b>Treatment Procedure</b>{" "}
            </td>
            <td width="15%" className="secondaryTableHead">
              <b>Quantity</b>
            </td>
            <td width="20%" className="secondaryTableHead">
              <b>Rate</b>
            </td>
            <td width="20%" className="secondaryTableHead">
              <b>Total</b>
            </td>
          </tr>
          {billingOrderDetails.map((itemDetail) => {
            // setSubTotal(subTotal+1)
            // setSubTotal(subTotal+(itemDetail.qty * parseInt(itemDetail.mrp)))
            return (
              <tr>
                <td className="primaryTableHead">
                  {" "}
                  {itemDetail.service_extra_name}{" "}
                </td>
                <td className="secondaryTableHead">{itemDetail.qty}</td>
                <td className="secondaryTableHead">
                  {parseInt(itemDetail.mrp)}
                </td>
                <td className="secondaryTableHead">
                  {itemDetail.qty * parseInt(itemDetail.mrp)}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {/* Bill details info  */}
      {/* Bill Details end  */}
      {/* Bill summary  */}
      {/* Bill summary end  */}
      <table width="100%" style={{ marginTop: 0 }}>
        <tbody>
          <tr>
            <td width="50%">
              <table width="100%" style={{ borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td width="50%" className="currencyTitle">
                      Pre. Due
                    </td>
                    <td width="32%" className="currencyBdt">
                      0.00
                    </td>
                    <td width="18%" className="currencyBdt">
                      Paid By
                    </td>
                  </tr>
                  {billingOrderTransactoins.map((transactionDetail) => (
                    <tr>
                      <td width="50%" className="currencyTitle">
                        Paid at{" "}
                        {serverDateToReadableDate(transactionDetail.created_at)}
                      </td>
                      <td width="32%" className="currencyBdt">
                        {parseInt(transactionDetail.tr_amount)}
                      </td>
                      <td width="18%" className="currencyBdt">
                        {transactionDetail.payment_type}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
            <td width="50%">
              <table
                width="100%"
                style={{ borderCollapse: "collapse", fontWeight: 500 }}
              >
                <tbody>
                  <tr>
                    <td width="50%" className="currencyTitle">
                      Sub Total
                    </td>
                    <td width="32%" className="currencyBdt">
                      {" "}
                      {subTotal}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" className="currencyTitle">
                      Discount
                    </td>
                    <td width="32%" className="currencyBdt">
                      {" "}
                      {parseInt(billingOrderMasters.discount)}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" className="currencyTitle">
                      Net Payable(+Pre. Due)
                    </td>
                    <td width="32%" className="currencyBdt">
                      {subTotal - parseInt(billingOrderMasters.discount)}
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" className="currencyTitle">
                      Total Paid
                    </td>
                    <td width="32%" className="currencyBdt">
                      {parseInt(billingOrderMasters.total_paid)}
                    </td>
                  </tr>
                  <tr>
                    <td width="50%" className="currencyTitle">
                      Due
                    </td>
                    <td width="32%" className="currencyBdt">
                      {subTotal -
                        parseInt(billingOrderMasters.discount) -
                        parseInt(billingOrderMasters.total_paid)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  );
};

export default BillPrintBody;
